import { render, staticRenderFns } from "./PurchasesInstrumentsPie.vue?vue&type=template&id=3f46c1f0&scoped=true"
import script from "./PurchasesInstrumentsPie.vue?vue&type=script&lang=js"
export * from "./PurchasesInstrumentsPie.vue?vue&type=script&lang=js"
import style0 from "./PurchasesInstrumentsPie.vue?vue&type=style&index=0&id=3f46c1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f46c1f0",
  null
  
)

export default component.exports